import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PasswordModule } from "primeng/password";
import { CheckboxModule } from "primeng/checkbox";
import { LoginDialogComponent } from "../login-dialog/login-dialog.component";
import { IUser } from "../interfaces/IUser";
import { EUserType } from "../enums/EUserType";
import { UserService } from "../service/user.service";
import { NotificationService } from "../service/notification.service";
import { DropdownModule } from "primeng/dropdown";
// import { CitiesService } from "../service/cities.service";
import { UtilsService } from '../service/utils.service';
import { ELocalStorage } from "../enums/ELocalStorage";

@Component({
    selector: 'app-registration',
    standalone: true,
    imports: [InputTextModule, ReactiveFormsModule, PasswordModule, CheckboxModule, LoginDialogComponent, DropdownModule, NgIf],
    templateUrl: './registration.component.html',
    styleUrl: './registration.component.scss'
})
export class RegistrationComponent implements OnInit {
    form: FormGroup | any;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    cityList: any;

    constructor(public userService: UserService,
        private fb: FormBuilder,
        public utilsService: UtilsService,
        private ns: NotificationService,
        // private citiesService: CitiesService
    ) {
    }

    createForm() {
        this.form = this.fb.group({
            usr_companyName_str: ['', Validators.required],
            usr_customerName_str: ['', Validators.required],
            usr_email_str: <any>['', Validators.required],
            usr_mobile_number_num: ['', Validators.required],
            usr_userName_str: ['', Validators.required],
            usr_sec_mobile_number_num: [null],
            usr_pass_str: ['', Validators.required],
            usr_cityName_str: ['', Validators.required],
            usr_district_str: ['', Validators.required],
            usr_gstNumber_str: [''],
            usr_state_str: ['', Validators.required],
            usr_pincode_num: ['', Validators.required],
            usr_agreeTermsAndConditions_bl: [false, Validators.required],
            usr_address_str: ['', Validators.required],
        });
    }

    async ngOnInit() {
        this.createForm();

        let defaultAMToken: any = await this.userService.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);

        // await this.getCities();
    }

    // async getCities() {
    //     this.cityList = await this.citiesService.query({ find: { active: true, }, });
    // }

    validEmail() {
        if (this.form.get('usr_email_str').value.length <= 2) return;
        // this.disableSendPinBtn = !!this.form.get('usr_email_str').hasError('pattern');
    }

    async onSubmit() {
        let formData: IUser = this.form.getRawValue();
        formData.usr_type_str = EUserType.USER;
        formData.createdAt = new Date();
        formData.active = true;
        formData.usr_isApproved_bl = false;

        if (!formData.usr_companyName_str) return this.ns.showError('Please Enter Company name.');
        if (!formData.usr_customerName_str) return this.ns.showError('Please Enter Your name.');
        if (!formData.usr_email_str) return this.ns.showError('Please Enter Email.');
        if (!this.emailPattern.test(formData.usr_email_str)) {
            return this.ns.showError('Please enter a valid Email.');
        }
        if (!formData.usr_userName_str) return this.ns.showError('Please Enter User name.');
        if (!formData.usr_mobile_number_num) return this.ns.showError('Please Enter Mobile number.');
        const mobileRegex = /^[0-9]{10}$/;
        if (!mobileRegex.test(formData.usr_mobile_number_num.toString())) {
            return this.ns.showError('Please enter a valid 10-digit Mobile Number');
        }
        if (!formData.usr_pass_str) return this.ns.showError('Please Enter Password.');
        if (!formData.usr_address_str) return this.ns.showError('Please Enter Address.');
        if (!formData.usr_cityName_str) return this.ns.showError('Please Select City.');
        if (!formData.usr_district_str) return this.ns.showError('Please Enter District.');
        if (!formData.usr_state_str) return this.ns.showError('Please Enter State.');
        if (!formData.usr_pincode_num) return this.ns.showError('Please Enter Pin Code.');
        if (!formData.usr_agreeTermsAndConditions_bl) return this.ns.showError('Please agree to the Terms & Conditions.');
        try {
            let resp = await this.userService.newUserRegister(formData);
            if (resp?._id) {
                this.ns.showSuccess(
                    `Thank you for registering with us ${this.form.get('usr_customerName_str')?.value}`
                );
                this.form.reset();
            } else {
                this.ns.showError("Please provide valid details!");
            }
        } catch (e: any) {
            const errorMsg = e?.error?.errors?.[0]?.message || e?.error?.message || e?.message || '';
            if (errorMsg.includes("duplicate") && errorMsg.includes("usr_userName_str")) {
                this.ns.showError("Username already in use, please try a different one.");
            } else if (errorMsg.includes("duplicate") && errorMsg.includes("usr_email_str")) {
                this.ns.showError("email id already in use, please try a different one.");
            } else {
                this.ns.showErrorFromResponse(e?.error || e, 'Unable to register.');
            }
        }
    }
}
